import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { lastValueFrom } from 'rxjs';
import {
    ISetCookie,
    IFamilyListResponse,
} from 'src/app/interfaces/family.interfaces';
import { HttpNewService } from 'src/app/services/application/http-new.service';
import { AuthService } from 'src/app/services/auth.service';
import { CookieConsentService } from 'src/app/services/cookie-consent/cookie-consent-service';
import { Store } from 'src/app/services/store.service';
import { AlertService } from 'src/lib/ariadna/alert';
import { Utils } from 'src/app/services/utils';
@Component({
    selector: 'app-family-access',
    templateUrl: './family-access.component.html',
    styleUrls: ['./family-access.component.scss'],
    standalone: false,
})
export class FamilyAccessComponent {
    public familyList?: IFamilyListResponse[];
    public isLoadData: boolean = true;
    public selectedFamilyMemberId: number | null = null;
    public constructor(
        private httpService: HttpNewService,
        private dialogRef: MatDialog,
        private auth: AuthService,
        private cookieService: CookieConsentService,
        private alert: AlertService,
    ) {}

    public ngOnInit(): void {
        this.getFamilyAccessList();
    }

    public async getFamilyAccessList(): Promise<void> {
        try {
            const result = await lastValueFrom(
                this.httpService.get<Array<IFamilyListResponse>>(
                    '/family/list/relatives',
                ),
            );
            this.familyList = result;
        } catch (e: unknown) {
            this.alert.error(Utils.getErrorMessage(e));
        } finally {
            this.isLoadData = false;
        }
    }
    public async submitMember() {
        try {
            this.isLoadData = true;
            const result = await lastValueFrom(
                this.httpService.get<ISetCookie>('/family/set/cookie', {
                    cookieId: this.selectedFamilyMemberId,
                    isSetParentCookie: 'false',
                }),
            );
            Store.setStringData('ParentCookieName', result.name);
            window.location.reload();
            return;
        } catch (e: unknown) {
            const errMsg =
                e instanceof Error ? e.message : 'Неизвестная ошибка';
            this.alert.error(
                `Произошла непредвиденная ошибка: ${errMsg}`,
                2000,
            );
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        }
    }

    public closeModal() {
        this.dialogRef.closeAll();
    }
}
